/* istanbul ignore file */
import React, { PureComponent } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@mummssoftware/common-ui';
import { auth } from '@mummssoftware/utils';
import {
  flattenedTranslationMessages as translationMessages,
  DEFAULT_LOCALE,
} from './i18n';
import globalStyles from './globalStyles';
import App from './components/App/App';

const handleEmbed = (embed) => {
  if (typeof embed === 'boolean') {
    return embed;
  } else if (embed === 'true') {
    return true;
  }
  return false;
};

// stand alone url is http://reactdev.mumms.com:3000/?patient=13773&agency=demo1

/**
 * @extends {PureComponent<ClearScriptsProps>}
 */
class ClearScripts extends PureComponent {
  /**
   * @param {ClearScriptsProps} props
   */
  constructor(props) {
    super(props);
    if (typeof props.setTokens === 'function') {
      props.setTokens(props.keycloak);
    }
    const { agency, patientNumber, keycloak } = props;
    if (agency) {
      this.agency = agency;
    } else {
      // if the agency has not been passed as props and this could be an admin check if in url
      // if ADMIN agency in the URL
      const query = new URLSearchParams(window.location.search);
      const adminAgency = query.get('agency');
      if (adminAgency) {
        this.agency = adminAgency;
      } else {
        // NON ADMIN look for agency in keycloack
        const parsedAgency = auth.getLdapDn(keycloak.idTokenParsed);
        this.agency = auth.getAgency(parsedAgency);
      }
    }
    if (patientNumber) {
      this.patientNumber = patientNumber;
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.patientNumber = window.location.pathname.substring(1).split('/')[0];
    }
  }

  render() {
    const {
      embedded,
      dashboardEmbedded,
      appTitle,
      online,
      readonly,
      hideActionBar,
      medications,
      onClick,
      onRemove,
      doNotShow,
      keycloak,
      logout,
      patientTopBar,
      smallWidget,
      doctors,
      currentUser,
      patient,
      dateTo,
      dateFrom,
      toSearch,
      locale: passedLocale,
      onError,
      theme,
      viewMode,
      printConfig,
      maintainMed,
      watermark,
      onWidgetReady,
      isDoctor,
      selectedDoctor,
      siteId,
      fromCERT,
      idgData,
    } = this.props;

    const useGlobalStyles = globalStyles;
    const locale = passedLocale || DEFAULT_LOCALE;
    return (
      <IntlProvider
        locale={locale}
        key={locale}
        messages={translationMessages[locale]}
      >
        <ThemeProvider
          theme={theme || undefined}
          globalStyles={useGlobalStyles}
          suppressGlobal={!useGlobalStyles}
        >
          <BrowserRouter>
            <App
              embedded={handleEmbed(embedded)}
              dashboardEmbedded={dashboardEmbedded}
              appTitle={appTitle}
              online={online}
              readonly={readonly}
              maintainMed={maintainMed}
              patientTopBar={patientTopBar}
              medications={medications}
              hideActionBar={hideActionBar}
              onClick={onClick}
              onRemove={onRemove}
              doNotShow={doNotShow}
              onError={onError}
              to={dateTo}
              from={dateFrom}
              agency={this.agency}
              toSearch={toSearch}
              patientNumber={this.patientNumber || patient?.patientNumber}
              keycloak={keycloak}
              doctors={doctors}
              currentUser={currentUser}
              patient={patient}
              smallWidget={smallWidget}
              logout={online ? logout || keycloak.logout : null}
              watermark={watermark}
              viewMode={viewMode}
              printConfig={printConfig}
              onWidgetReady={onWidgetReady}
              isDoctor={isDoctor}
              selectedDoctor={selectedDoctor}
              siteId={siteId}
              fromCERT={fromCERT}
              idgData={idgData}
            />
          </BrowserRouter>
        </ThemeProvider>
      </IntlProvider>
    );
  }
}

export default ClearScripts;
